import React, { useEffect, useState } from "react";
import "../styles/home.css";
import ImageSlider from "./ImageSlider";
import Aos from "aos";
import "aos/dist/aos.css";

import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import { initializeApp } from "firebase/app";

import { register } from "swiper/element/bundle";
register();

// Default Image
const DEFAULT_IMAGE =
  "https://res.cloudinary.com/dgtpy2d2i/image/upload/v1784053276/iskconpurislider_lpuacq.png";

const firebaseConfig = {
  apiKey: "AIzaSyAgdH2mmvs0U-pd_9DuKAzXlayrjxu9Dr8",
  authDomain: "iskconpuriglowal.firebaseapp.com",
  projectId: "iskconpuriglowal",
  storageBucket: "iskconpuriglowal.appspot.com",
  messagingSenderId: "813384272467",
  appId: "1:813384272467:web:5070fa8f06aceb182d94a6",
  measurementId: "G-1S8GH5W9ZD",
};

export default function Home() {
  // Show default image initially
  const [slides, setImageUrls] = useState([DEFAULT_IMAGE]);

  useEffect(() => {
    const app = initializeApp(firebaseConfig);

    const storage = getStorage(app);
    const storageRef = ref(storage, "DonationPage-Slider");

    listAll(storageRef)
      .then((result) => {
        // Folder is empty
        if (result.items.length === 0) {
          setImageUrls([DEFAULT_IMAGE]);
          return [];
        }

        return Promise.all(
          result.items.map((imageRef) => getDownloadURL(imageRef))
        );
      })
      .then((urls) => {
        if (urls.length > 0) {
          setImageUrls(urls);
        } else {
          setImageUrls([DEFAULT_IMAGE]);
        }
      })
      .catch((error) => {
        console.error("Error fetching images:", error);

        // Firebase error -> show default image
        setImageUrls([DEFAULT_IMAGE]);
      });
  }, []);

  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <div className="homeee">
        <ImageSlider slides={slides} />
      </div>

      <div className="homeDescription">
        <h3
          data-aos="fade-up"
          data-aos-easing="ease-in-sine"
          data-aos-delay="300"
        >
          We request you to Join our hands to support this initiative for
          keeping
          <br />
          this distribution enduring.
        </h3>
      </div>
    </>
  );
}
